import React from 'react';
import PropTypes from 'prop-types';

import 'src/app/components/Layout/Layout.scss';


const Layout = ({ children }) => (
  <div styleName="layout">
    { children }
  </div>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
